import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpArgumentOperandDependencyFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpAdditionalDataFactory } from "./ExpAdditionalData";

/**
 * Defines a dependency for this argument operand. A dependency can be either another operand, or an operand group. Only one of operandName or groupId should be populated. 
 * @export
 * @interface ExpArgumentOperandDependency
 */

export class ExpArgumentOperandDependencyFactory {}
_ExpArgumentOperandDependencyFactory = ExpArgumentOperandDependencyFactory;
_defineProperty(ExpArgumentOperandDependencyFactory, "FromJSON", function (json) {
  return _ExpArgumentOperandDependencyFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpArgumentOperandDependencyFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'operandName': json['operandName'],
    'groupID': json['groupID'],
    'additionalData': json['additionalData'] === null || json['additionalData'] === undefined ? json['additionalData'] : ExpAdditionalDataFactory.FromJSON(json['additionalData'])
  };
});
_defineProperty(ExpArgumentOperandDependencyFactory, "ToJSON", function (value) {
  return _ExpArgumentOperandDependencyFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpArgumentOperandDependencyFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'operandName': value.operandName,
    'groupID': value.groupID,
    'additionalData': ExpAdditionalDataFactory.ToJSON(value.additionalData)
  };
});
//# sourceMappingURL=ExpArgumentOperandDependency.js.map
